import { HighlightOffOutlined } from '@mui/icons-material';
import { Dialog } from '@mui/material';
import React, { useEffect, useState } from 'react';
import '../../ProductIngredients.css';

const parseData = (raw) => {
    if (!raw) return null;
    try {
        const parsed = JSON.parse(raw);
        if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) return parsed;
    } catch (e) {}
    return null;
};

const ProductIngredientsView = ({ open, onClose, prodName, moreProductDetails }) => {
    const [data, setData] = useState(null);

    useEffect(() => {
        if (open) setData(parseData(moreProductDetails));
    }, [open, moreProductDetails]);

    const renderSection = (section, i) => {
        const { title, type, items, label } = section;
        return (
            <div key={i} className="section">
                {title && <div className="section-title">{title}</div>}
                {type === 'metrics' ? (
                    <div className="grid">
                        {(items || []).map((item, j) => (
                            <div key={j} className="metric">
                                <div className="m-label">{item.label}</div>
                                <div className="m-value">
                                    {item.value} <span className="m-unit">{item.unit}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : type === 'badges' ? (
                    <div className="row">
                        <span className="label">{label || 'מכיל'}</span>
                        <span className="value">
                            {(items || []).map((badge, j) => (
                                <span key={j} className="badge">{badge}</span>
                            ))}
                        </span>
                    </div>
                ) : (
                    (items || []).map((item, j) => (
                        <div key={j} className="row">
                            <span className="label">{item.label}</span>
                            <span className="value">{item.value}</span>
                        </div>
                    ))
                )}
            </div>
        );
    };

    return (
        <Dialog onClose={onClose} open={open} className="IngridsPop" style={{ zIndex: 99999 }}>
            <div className="IngridsPop-header">
                <HighlightOffOutlined className="pointing" onClick={onClose} style={{ cursor: 'pointer' }} />
                <div className="bold big centerText">
                    <span>{prodName}</span>
                </div>
                <span style={{ width: 32 }} />
            </div>
            <div className="ingr-content" dir="rtl">
                {data ? (
                    <div className="card" dir="rtl">
                        {(data.title || data.subtitle) && (
                            <div className="header">
                                {data.title && <div className="title">{data.title}</div>}
                                {data.subtitle && <div className="subtitle">{data.subtitle}</div>}
                            </div>
                        )}
                        {(data.sections || []).map((sec, i) => renderSection(sec, i))}
                        {data.note && <div className="note">{data.note}</div>}
                    </div>
                ) : (
                    <div style={{ textAlign: 'center', color: '#999', padding: '2rem', fontSize: 14 }}>
                        אין מידע על מרכיבים
                    </div>
                )}
            </div>
        </Dialog>
    );
};

export default ProductIngredientsView;
